'use client';

import { useEffect } from 'react';
import { usePathname } from 'next/navigation';
import { removeLastShopPosition } from '../../_ui/modules/ShopProductGrid/utils';

export const ShopPositionTracker = () => {
  const pathname = usePathname();

  useEffect(() => {
    // reset last shop position if the user navigated to another page
    if (pathname !== '/shop' && !pathname.startsWith('/product/')) {
      removeLastShopPosition();
    }
  }, [pathname]);

  return null;
};
